(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/betslip.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/betslip.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useRef = _React.useRef;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const COUPON_VALID = svs.components.tipsen.engine.constants.couponStatus.COUPON_VALID;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectBetslipCouponType = _svs$components$tipse.selectBetslipCouponType,
  selectCouponStatus = _svs$components$tipse.selectCouponStatus,
  makeSelectIsCouponEmpty = _svs$components$tipse.makeSelectIsCouponEmpty,
  selectIsRSystemChosen = _svs$components$tipse.selectIsRSystemChosen,
  selectIsUSystemChosen = _svs$components$tipse.selectIsUSystemChosen,
  selectIsReduceSystemChosen = _svs$components$tipse.selectIsReduceSystemChosen,
  selectCouponSignCount = _svs$components$tipse.selectCouponSignCount,
  selectMSignsCount = _svs$components$tipse.selectMSignsCount,
  selectUSignsCount = _svs$components$tipse.selectUSignsCount,
  selectValidCouponEvents = _svs$components$tipse.selectValidCouponEvents,
  selectCouponEventCount = _svs$components$tipse.selectCouponEventCount,
  selectPrice = _svs$components$tipse.selectPrice;
const BetslipContext = svs.components.tipsen.betslipComponents.BetslipContext;
const Betslip = _ref => {
  let children = _ref.children;
  const couponId = useCouponId();
  const couponStatus = useSelector(state => selectCouponStatus(state, couponId));
  const couponType = useSelector(state => selectBetslipCouponType(state, couponId));
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const isMedium = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const _useState = useState(!isExtraSmall || couponStatus === COUPON_VALID),
    _useState2 = _slicedToArray(_useState, 2),
    isBetslipVisible = _useState2[0],
    setIsBetslipVisible = _useState2[1];
  const selectIsCouponEmpty = useRef(makeSelectIsCouponEmpty());
  const couponSignCount = useSelector(state => selectCouponSignCount(state, couponId));
  const uSignCount = useSelector(state => selectUSignsCount(state, couponId));
  const mSignCount = useSelector(state => selectMSignsCount(state, couponId));
  const isCouponEmpty = useSelector(state => selectIsCouponEmpty.current(state, couponId));
  const isRsystemSet = useSelector(state => selectIsRSystemChosen(state, couponId));
  const isUsystemSet = useSelector(state => selectIsUSystemChosen(state, couponId));
  const isReduceSystem = useSelector(state => selectIsReduceSystemChosen(state, couponId));
  const couponEventsStarted = useSelector(state => selectValidCouponEvents(state, couponId, 0));
  const couponEventCount = useSelector(state => selectCouponEventCount(state, couponId, 0));
  const isCouponValid = useMemo(() => couponStatus === COUPON_VALID, [couponStatus]);
  const price = useSelector(state => selectPrice(state, couponId, true));
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCouponValidWithDelay = _useState4[0],
    setIsCouponValidWithDelay = _useState4[1];

  useEffect(() => {
    let timeoutId;
    if (isCouponValid) {
      timeoutId = setTimeout(() => {
        setIsCouponValidWithDelay(true);
      }, 500);
    } else {
      setIsCouponValidWithDelay(false);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isCouponValid]);
  const context = useMemo(() => ({
    couponBetButtonCount: couponSignCount + uSignCount + mSignCount,
    couponEventCount,
    couponEventsStarted,
    couponId,
    couponType,
    isAnySystemSelected: isRsystemSet || isUsystemSet || isReduceSystem,
    isBetslipVisible,
    isCouponEmpty,
    isCouponValid,
    isCouponValidWithDelay,
    isExtraSmall,
    isMedium,
    isReduceSystem,
    isRsystemSet,
    isUsystemSet,
    price,
    setIsBetslipVisible,
    couponStatus
  }), [couponEventCount, couponEventsStarted, couponId, couponSignCount, couponType, isBetslipVisible, isCouponEmpty, isCouponValid, isCouponValidWithDelay, isExtraSmall, isMedium, isReduceSystem, isRsystemSet, isUsystemSet, mSignCount, price, uSignCount, couponStatus]);
  return React.createElement(BetslipContext.Provider, {
    value: context
  }, children);
};
setGlobal('svs.components.tipsen.betslipComponents.Betslip', Betslip);

 })(window);